import React from 'react';

import SoftySupervisorDetalle from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftySupervisor/SoftySupervisorDetalle/List.js';

export default function () {
  return <SoftySupervisorDetalle />;
}
